"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var antd_1 = require("antd");
var pt_BR_1 = __importDefault(require("antd/lib/locale-provider/pt_BR"));
var en_US_1 = __importDefault(require("antd/lib/locale-provider/en_US"));
require("moment/locale/pt");
var localeMap = {
    'pt-BR': pt_BR_1.default,
    'en-US': en_US_1.default,
};
var LocaleProvider = function (_a) {
    var children = _a.children;
    var i18n = react_i18next_1.useTranslation().i18n;
    return react_1.default.createElement(antd_1.ConfigProvider, { locale: localeMap[i18n.language] }, children);
};
exports.default = LocaleProvider;
